<template>
  <div
    class="absolute w-64 z-50 text-white text-sm overflow-scroll" style="max-height: 420px"
    :style="
      alignTopRight === true
        ? 'top:' + position.top + 'px; left:' + (position.right - 256) + 'px;'
        : 'top:' + position.top + 'px; left:' + position.left + 'px;'
    "
  >
    <div class="bg-black py-2 rounded-b-none rounded-lg" :class="[withIcon ? 'px-3' : 'pl-1 pr-3']">
      <div class="flex items-center">
        <img v-if="withIcon" class="w-5 h-5" :src="icon" alt="Format" />
        <div class="flex-grow px-2">{{ title }}</div>
        <img
          v-if="!isInEditMode"
          class="w-4 h-4 cursor-pointer"
          src="../../assets/icons/close.svg"
          alt="Fermer"
          @click="$emit('closeMenu')"
        />
        <img
          v-else
          class="w-6 h-6 cursor-pointer"
          src="../../assets/icons/edit.svg"
          alt="Editer"
          @click="
            edited = true
            isInEditMode = false
          "
        />
      </div>
    </div>
    <Contributions @closeMenu="$emit('closeMenu')" v-if="name === 'contributions'" />
    <Characters @closeMenu="$emit('closeMenu')" v-if="name === 'characters'" />
    <Format @closeMenu="$emit('closeMenu')" v-if="name === 'format'" />
    <Infos v-if="name === 'infos'" />
    <Arrangement @closeMenu="$emit('closeMenu')" v-if="name === 'arrangement'" />
    <Order @closeMenu="$emit('closeMenu')" v-if="name === 'order'" />
    <FilterMenu @closeMenu="$emit('closeMenu')" v-if="name === 'filter'" />
    <Select v-if="name === 'select'" />
    <SelectLabel v-if="name === 'selectLabel'" :label="label" />
    <Label
      @isInEditMode="
        isInEditMode = true
        edited = false
      "
      @edited="
        isInEditMode = false
        edited = true
      "
      v-if="name === 'label'"
      :edited="edited"
    />
    <LabelDelete @closeMenu="$emit('closeMenu')" v-if="name === 'labelDelete'" :editedIndex="editedIndex" />
    <LabelNew @closeMenu="$emit('closeMenu')" v-if="name === 'labelNew'" />
    <OtherDisplays
      @isInEditMode="
        isInEditMode = true
        edited = false
      "
      @edited="
        isInEditMode = false
        edited = true
      "
      @closeMenu="$emit('closeMenu')"
      :edited="edited"
      :realItemsPerLine="realItemsPerLine"
      v-if="name === 'otherDisplays'"
    />
    <New @closeMenu="$emit('closeMenu')" v-if="name === 'new'" />
    <Live @closeMenu="$emit('closeMenu')" @toggleMenu="$emit('toggleMenu', $event)" v-if="name === 'live'" />
    <Timer @closeMenu="$emit('closeMenu')" v-if="name === 'timer'" />
    <ActiveAuto @closeMenu="$emit('closeMenu')" v-if="name === 'activeAuto'" />
    <Sync @closeMenu="$emit('closeMenu')" v-if="name === 'sync'" />
  </div>
</template>

<script>
import Contributions from "./Contributions"
import Characters from "./Characters"
import Format from "./Format"
import Infos from "./Infos"
import Arrangement from "./Arrangement"
import Order from "./Order"
import FilterMenu from "./Filter" // can't use reserved word Filter as component name
import Select from "./Select"
import SelectLabel from "./SelectLabel"
import Label from "./Label"
import LabelDelete from "./LabelDelete"
import LabelNew from "./LabelNew"
import New from "./New"
import OtherDisplays from "./OtherDisplays"
import Live from "./Live"
import ActiveAuto from "./ActiveAuto"
import Timer from "./Timer"
import Sync from "./Sync"

const MenuTitles = Object.freeze({
  CONTRIBUTIONS: "Nombre de contributions",
  CHARACTERS: "Nombre de caractères",
  FORMAT: "Format",
  INFOS: "Informations affichées",
  ARRANGEMENT: "Rangement",
  ORDER: "Ordre d'affichage instantané",
  FILTER: "Filtres",
  SELECT: "Sélection",
  SELECTLABEL: "Sélection Label",
  LABEL: "Labels",
  LABELDELETE: "Supprimer le label",
  LABELNEW: "Appliquer le label",
  NEW: "Ajouter une contribution",
  OTHERDISPLAYS: "Afficher :",
  LIVE: "Participation",
  TIMER: "Durée du timer",
  ACTIVEAUTO: "Automatiser la participation",
  SYNC: "Récupérer les infos la question",
})

export default {
  props: {
    name: String,
    position: Object,
    withIcon: Boolean,
    editedIndex: Number,
    alignTopRight: Boolean,
    realItemsPerLine: Number,
    label: Object,
  },
  data() {
    return {
      isInEditMode: false,
      edited: true,
    }
  },
  computed: {
    title() {
      if (this.isInEditMode && name === "label") {
        return MenuTitles[this.name.toUpperCase()].slice(0, -1)
      }
      return MenuTitles[this.name.toUpperCase()]
    },
    icon() {
      try {
        return require("@/assets/icons/" + this.name + ".svg")
      } catch (e) {
        return null
      }
    },
  },
  components: {
    Contributions,
    Characters,
    Format,
    Infos,
    Arrangement,
    Order,
    FilterMenu,
    Select,
    SelectLabel,
    Label,
    LabelDelete,
    LabelNew,
    New,
    OtherDisplays,
    Live,
    ActiveAuto,
    Timer,
    Sync,
  },
}
</script>

<style></style>
